import { useQuery } from "@tanstack/react-query";
import { fetchArchivedPlaylistCountsByShow } from "@src/apis/showApis";
import { QUERY_KEYS } from "@src/queries/queryKeys";

interface UseArchivedPlaylistCountsResult {
  countsByShow: Record<string, number>;
  loadingCounts: boolean;
}

export const useArchivedPlaylistCounts =
  (): UseArchivedPlaylistCountsResult => {
    const { data, isLoading } = useQuery({
      queryKey: [QUERY_KEYS.ARCHIVED_PLAYLIST_COUNT, "byShow"],
      queryFn: fetchArchivedPlaylistCountsByShow,
      staleTime: 5 * 60 * 1000,
    });

    return {
      countsByShow: data ?? {},
      loadingCounts: isLoading,
    };
  };
